export const events = {
  mtsSpaCyber: 'mtsSpaCyber',
  mtsPageview: 'mtsPageview',
} as const

export const eventCategories = {
  igrovayaStranica: 'igrovaya_stranica',
  avtorizaciya: 'avtorizaciya',
} as const

export const eventActions = {
  buttonClick: 'button_click',
  elementClick: 'element_click',
  cardClick: 'card_click',
  cardShow: 'card_show',
  formAdd: 'form_add',
  popupShow: 'popup_show',
  screenShow: 'screen_show',
  errorShow: 'error_show',
  formConfirmed: 'form_confirmed',
  formRejected: 'form_rejected',
} as const

export const eventLabels = {
  glavnaya: 'glavnaya',
  steam: 'steam',
  igry: 'igry',
  servicy: 'servicy',
  igrovyeKlyuchi: 'igrovye_klyuchi',
  esche: 'esche',
  poisk: 'poisk',
  vydachaPoiska: 'vydacha_poiska',
  voiti: 'voiti',
  storis: 'storis',
  podrobnee: 'podrobnee',
  populyarnoe: 'populyarnoe',
  novosti: 'novosti',
  categoryStranica: 'category_stranica',
  oshibka: 'oshibka',
  oshibka404: 'oshibka_404',
  rekvizity: 'rekvizity',
  reklamnyiBanner: 'reklamnyi_banner',
  loginMail: 'login_mail',
  sum: 'sum',
  promokod: 'promokod',
  podarochnayaKarta: 'podarochnaya_karta',
  kupit: 'kupit',
  voitiOplatitit: 'voiti_oplatitit',
  oplataQr: 'oplata_qr',
  platezhOtpravlen: 'platezh_otpravlen',
  platezhVObrabotke: 'platezh_v_obrabotke',
  platezhNeOtpravlen: 'platezh_ne_otpravlen',
  tarif: 'tarif',
} as const

export const eventContents = {
  perekluchenieRazdela: 'perekluchenie_razdela',
  glavnaya: 'glavnaya',
  storis: 'storis',
  rekvizity: 'rekvizity',
  igry: 'igry',
  servisy: 'servisy',
  igrovyeKluchi: 'igrovye_kluchi',
  novosti: 'novosti',
} as const

export const actionGroups = {
  interactions: 'interactions',
  nonInteractions: 'non_interactions',
} as const

export const pageType = '/cyber'

export const entryPoints = {
  direct: 'direct',
  populyarnoe: 'populyarnoe',
  servisy: 'servisy',
  poisk: 'poisk',
  storis: 'storis',
  reklamnyiBanner: 'reklamnyi_banner',
  categoryStranica: 'category_stranica',
} as const

export const paymentMethods = {
  sbp: 'sbp',
  mtsAccount: 'mts_account',
} as const

export const eventContexts = {
  sbp: 'sbp',
  schetMts: 'schet_mts',
} as const

export const amountSources = {
  rekvizity: 'rekvizity',
  podarochnayaKarta: 'podarochnaya_karta',
} as const

export const homeTabs = {
  glavnaya: 'glavnaya',
  steam: 'steam',
  igry: 'igry',
  servisy: 'servisy',
  esche: 'esche',
} as const

export const failReasons = {
  nedostatochnoSredstv: 'nedostatochno_sredstv',
} as const

export const productNames = {
  steam: 'Steam',
  igrovayaStranica: 'igrovaya_stranica',
} as const
